module.exports = __webpack_public_path__ + "media/img/aconitas-pps-logo-743338726acf1bace6d803b19e409ae8.svg";